const PORTFOLIO_VISUALIZATION_TAB = {
  portfolio: 0,
  virtualPortfolio: 1,
} as const;

export { PORTFOLIO_VISUALIZATION_TAB };
